import { MovieIcon } from './MovieIcon';

/**
 * author: Google
 * id 122C53AA-C8BC-41B3-89B2-B9A9F8BB56DC
 * name movie
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie.svg
 * tags
 * - Video / Movie 
 */
export const SlateIcon = MovieIcon;
export default SlateIcon